export default "__VITE_ASSET__mw7MmDLH__"